if (!customElements.get('mobile-dock')) {
  customElements.define(
    'mobile-dock',
    class MobileDock extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      
      get section() {
        return this._section = this._section || this.closest('.mobile-dock-section');
      }
      
      init() {
        if (this.initialized) return;
        this.initialized = true;
        this.setAttribute('loaded', '');
        
        // --- NEW HOMEPAGE CHECK START ---
        // We check if the current page path is exactly "/" (the homepage)
        if (window.location.pathname === '/') {
          // If YES, we set up the special transparent-on-scroll behavior
          this.setupScrollListener();
        } else {
          // If NO (on any other page), we just make the dock active and solid.
          this.section.classList.add('active');
        }
        // --- NEW HOMEPAGE CHECK END ---
        
        setTimeout(this.setHeight.bind(this));
        document.addEventListener('matchSmall', this.setHeight.bind(this));
      }
      
      setupScrollListener() {
        // This is the trigger point in pixels from the top of the page.
        const triggerPoint = 60; 
        
        const handleScroll = () => {
          // This line ensures the dock is always visible on the homepage.
          this.section.classList.add('active');
  
          // Check if we are near the top or have scrolled past the trigger point.
          if (window.scrollY < triggerPoint) {
            this.section.classList.add('dock-is-transparent');
          } else {
            this.section.classList.remove('dock-is-transparent');
          }
        };
  
        // Set up the scroll listener.
        window.addEventListener('scroll', theme.utils.throttle(handleScroll), false);
        
        // Run the function once on page load to set the correct initial state.
        handleScroll(); 
      }
      
      setHeight() {
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
      }
    }
  );
}